export default __webpack_public_path__ + "static/media/siix_logo.1c33d14b.png";